module.exports = __webpack_public_path__ + "static/media/5.a7ea8347.jpg";